import ToolTip from 'antd/es/tooltip';
import styled from 'styled-components';

import { TTooltipProps } from './ToolTip.types';

const SToolTip = styled(ToolTip)<TTooltipProps>``;
export default SToolTip;
